module.exports = __webpack_public_path__ + "img/about-fox.76367221.png";